import styled from "@emotion/styled";
import {
  ActionIcon,
  type ActionIconProps,
  Badge,
  type BadgeProps,
  createPolymorphicComponent,
} from "@mantine/core";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;

export const Sky = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 58px 0 58px;

  background: ${({ theme }) => theme.colors.headerSky};
`;

export const Sea = styled.div`
  height: 52px;
  padding: 0 58px 0 58px;
  background-color: ${({ theme }) => theme.colors.headerSea};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LogoContainer = styled.div`
  height: 80px;
  margin: 5px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 50px;

  @media (max-width: 1200px) {
    display: none;
  }

  img {
    height: 80px;
  }
`;

const _HeaderIcon = styled(ActionIcon)`
  border: none;
  transition: 0.3s;
  &:hover {
    background-color: transparent !important;
    // background-color: ${({ theme }) => theme.colors.headerSea[0]};
    border: none;
    transform: translateY(-1px);
  }
`;

const _HeaderBadge = styled(Badge)`
  userselect: none;
  transition: transform 0.3s;
  &:hover {
    transform: translateY(-1px);
  }
`;

export const JustifyEnd = styled.div`
  display: flex;
  justify-content: end;
  gap: 40px;
  margin-left: 40px;
`;

export const FlexDiv = styled.div`
  display: flex;
  gap: 40px;
`;

export const HeaderIcon = createPolymorphicComponent<"button", ActionIconProps>(
  _HeaderIcon,
);

export const HeaderBadge = createPolymorphicComponent<"button", BadgeProps>(
  _HeaderBadge,
);
